var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 3.85522V1.98022C4.375 1.81446 4.44085 1.65549 4.55806 1.53828C4.67527 1.42107 4.83424 1.35522 5 1.35522H12.5C12.6658 1.35522 12.8247 1.42107 12.9419 1.53828C13.0592 1.65549 13.125 1.81446 13.125 1.98022V10.7302C13.125 10.896 13.0592 11.055 12.9419 11.1722C12.8247 11.2894 12.6658 11.3552 12.5 11.3552H10.625V13.2302C10.625 13.5752 10.3438 13.8552 9.99562 13.8552H2.50437C2.42195 13.8557 2.34025 13.8399 2.26395 13.8087C2.18765 13.7776 2.11827 13.7316 2.05979 13.6735C2.0013 13.6155 1.95487 13.5464 1.92316 13.4703C1.89145 13.3942 1.87508 13.3126 1.875 13.2302L1.87688 4.48022C1.87688 4.13522 2.15813 3.85522 2.50625 3.85522H4.375ZM3.12687 5.10523L3.125 12.6052H9.375V5.10523H3.12687ZM5.625 3.85522H10.625V10.1052H11.875V2.60522H5.625V3.85522Z",
    fill: "#0D458A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyImg);
export default __webpack_public_path__ + "static/media/copyImg.fe8b5fe10e6938ea96d9bf6813beeccb.svg";
export { ForwardRef as ReactComponent };